import React, { useState } from "react";
import EmptyStateContainer from "../../../themes/components/EmptyStateContainer";
import TagAssigneeFormDrawer from "./TagAssigneeFormDrawer";

type TagAssigneeTableEmptyStateContainerProps = {
  id: number;
};

const TagAssigneeTableEmptyStateContainer: React.FC<
  TagAssigneeTableEmptyStateContainerProps
> = ({ id }) => {
  const [opened, setOpened] = useState(false);
  return (
    <>
      <TagAssigneeFormDrawer
        id={id}
        opened={opened}
        onClose={() => setOpened(false)}
        assignee={[]}
      />
      <EmptyStateContainer
        title="You have no employees"
        description="There are no employees assigned to tag."
        button={{
          onClick: () => setOpened(true),
          title: "Add Employee",
        }}
      />
    </>
  );
};

export default TagAssigneeTableEmptyStateContainer;
